import {packLabel} from './catalogueMath'

/**
 * Verbatim from the real PRODUCT_MASTER_SAMPLE.csv, header order included.
 *
 * TWO MISSPELLINGS ARE DELIBERATE AND MUST NOT BE "FIXED":
 *   - the header `breath` (for breadth)
 *   - the sample value `Catogery of Product`
 * The live Proship importer matches on these exact strings. A merchant whose
 * file says `breadth` will not match, so silently correcting the template here
 * would teach the wrong header.
 *
 * The four columns this module actually reads are weight, length, breath and
 * height. `uom` is "gms/cm" — weight in grams, dimensions in centimetres —
 * which is what makes length x breath x height / 5000 the volumetric weight a
 * freeze is argued against.
 */
export const TEMPLATE_NAME = 'PRODUCT_MASTER_SAMPLE.csv'

export const TEMPLATE_COLS = [
  'skuCode', 'productId', 'name', 'brand', 'category', 'subCategory', 'mrp',
  'eanCode', 'upcCode', 'hsnCode', 'uom', 'weight', 'length', 'breath', 'height',
  'productStatus', 'imageUploaded',
  'image1', 'image2', 'image3', 'image4', 'image5',
  'image6', 'image7', 'image8', 'image9', 'image10',
]

const TEMPLATE_IMG = 'https://st.depositphotos.com/1186248/2751/i/950/depositphotos_27516565-stock-photo-free-sample.jpg'

export const TEMPLATE_ROW = [
  'a123', '12342', 'Product Name', 'Brand Name', 'Catogery of Product', 'Sub Category',
  '440', '', '', '21069099', 'gms/cm', '470', '19', '10', '8', '', 'Yes/No',
].concat(new Array(10).fill(TEMPLATE_IMG))

export const TEMPLATE_NOTES = {
  skuCode: 'Required. The code every other screen in this module keys on.',
  weight: 'Dead weight in grams. One half of what you are billed on.',
  length: 'Centimetres. Feeds volumetric weight.',
  breath: 'Centimetres. Spelled "breath" in the template — keep it.',
  height: 'Centimetres. Feeds volumetric weight.',
  uom: 'Leave as gms/cm. The importer reads weight and dimensions in those units.',
  subCategory: 'Freezes are agreed at this level by default, so fill it.',
  imageUploaded: 'Yes or No.',
}

/** Which template column feeds which Prozo field. Anything absent is stored but not read by weight freeze. */
export const TEMPLATE_FIELD_MAP = {
  skuCode: 'sku', category: 'cat', subCategory: 'sub',
  weight: 'dead', length: 'len', breath: 'bre', height: 'hgt',
}

export const MAP_TARGETS = [
  {value: 'sku', label: 'SKU code'},
  {value: 'cat', label: 'Category'},
  {value: 'sub', label: 'Sub-category'},
  {value: 'dead', label: 'Dead weight'},
  {value: 'len', label: 'Length (cm)'},
  {value: 'bre', label: 'Breadth (cm)'},
  {value: 'hgt', label: 'Height (cm)'},
  {value: 'pack', label: 'Default packing material'},
  {value: 'skip', label: 'Do not import'},
]

function csvCell(v) {
  const s = String(v == null ? '' : v)
  return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s
}

export function templateCsv() {
  return TEMPLATE_COLS.join(',') + '\n' + TEMPLATE_ROW.map(csvCell).join(',') + '\n'
}

/**
 * Built in the browser — no network, so it works from a downloaded offline
 * copy of the panel too. The object URL is revoked, unlike the mockup's DWS
 * uploader (see map §7 R4).
 */
export function downloadTemplate() {
  const blob = new Blob([templateCsv()], {type: 'text/csv;charset=utf-8'})
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = TEMPLATE_NAME
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/** The columns a brand's own export tends to carry. Samples come from the merchant's first real record so the mapping table reads against real data. */
export function sourceColumns(skus, packs) {
  const s = (skus || [])[0] || {}
  return [
    {column: 'Item Code', sample: s.sku || '', guess: 'sku'},
    {column: 'Product Title', sample: s.product || '', guess: 'skip'},
    {column: 'Category', sample: s.cat || '', guess: 'cat'},
    {column: 'Sub Category', sample: s.sub || '', guess: 'sub'},
    {column: 'Net Wt (gms)', sample: String(Math.round((s.deadKg || 0) * 1000)), guess: 'dead'},
    {column: 'Pack Type', sample: packLabel(packs, s.packId), guess: 'pack'},
    {column: 'Warehouse', sample: 'Primary FC', guess: 'skip'},
  ]
}
